/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Gallery_TitleInputs */

const en_directory_ai_tools_gallery_title = /** @type {(inputs: Directory_Ai_Tools_Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example rap duo videos`)
};

const zh_directory_ai_tools_gallery_title = /** @type {(inputs: Directory_Ai_Tools_Gallery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说唱二人组视频示例`)
};

/**
* | output |
* | --- |
* | "Example rap duo videos" |
*
* @param {Directory_Ai_Tools_Gallery_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_gallery_title = /** @type {((inputs?: Directory_Ai_Tools_Gallery_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Gallery_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_gallery_title(inputs)
	return zh_directory_ai_tools_gallery_title(inputs)
});
export { directory_ai_tools_gallery_title as "directory.ai_tools.gallery_title" }